/* v2-below.js - moved out of the page into a cached asset (was inline).
   Runs once per page; in the theme editor it re-runs when a section reloads,
   exactly as the inline version did. */
(function () {
if (window.__v2Asset_v2_below_js) return;
window.__v2Asset_v2_below_js = 1;
function v2run() {
(function () {
  'use strict';

  var root = document.querySelector('[data-v2-below]');
  if (!root) return;
  if (!document.querySelector('[data-v2-groups]')) { root.setAttribute('hidden', ''); return; }

  Array.prototype.forEach.call(root.querySelectorAll('[data-v2-row]'), function (btn) {
    var body = btn.nextElementSibling;
    if (!body) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) body.setAttribute('hidden', ''); else body.removeAttribute('hidden');
    });
  });

  (function () {
    var rail = root.querySelector('[data-v2-charm-rail]');
    var data = root.querySelector('[data-v2-charm-materials]');
    if (!rail) return;
    var map = {};
    if (data) { try { map = JSON.parse(data.textContent) || {}; } catch (e) { map = {}; } }

    var priceData = root.querySelector('[data-v2-charm-prices]');
    var priceMap = {};
    if (priceData) {
      try { priceMap = JSON.parse(priceData.textContent) || {}; } catch (e) { priceMap = {}; }
    }

    function handleOf(card) {
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return null;
      var rest = (a.getAttribute('href') || '').split('?')[0].split('/products/')[1];
      return rest ? rest.split('/')[0] : null;
    }

    var asked = {};
    function lookUp(h, apply) {
      if (Object.prototype.hasOwnProperty.call(asked, h)) {
        if (asked[h] && typeof asked[h].then === 'function') asked[h].then(apply);
        else apply(asked[h]);
        return;
      }
      var pending = fetch('/products/' + h + '?view=v2-specs', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) {
          var val = null;
          try { val = t ? (JSON.parse(t).material_collection || null) : null; } catch (e) { val = null; }
          asked[h] = val;
          if (val) map[h] = val;
          return val;
        })
        .catch(function () { delete asked[h]; return null; });
      asked[h] = pending;
      pending.then(apply);
    }

    function handleFromUrl(u) {
      var rest = String(u || '').split('?')[0].split('/products/')[1];
      return rest ? rest.split('/')[0].split('#')[0] : null;
    }
    function candidateHandles(card) {
      var out = [], seen = {};
      function push(h) { if (h && !seen[h]) { seen[h] = 1; out.push(h); } }
      Array.prototype.forEach.call(card.querySelectorAll('*'), function (el) {
        if (!el.attributes) return;
        for (var i = 0; i < el.attributes.length; i++) {
          var v = el.attributes[i].value;
          if (v && v.indexOf('/products/') > -1) push(handleFromUrl(v));
        }
      });
      return out;
    }
    var warmed = 0;
    function warm(card) {
      if (!card || card.getAttribute('data-v2-warm')) return;
      card.setAttribute('data-v2-warm', '1');
      var list = candidateHandles(card);
      for (var i = 0; i < list.length && warmed < 8; i++) {
        if (!Object.prototype.hasOwnProperty.call(map, list[i])) {
          warmed++;
          lookUp(list[i], function () {});
        }
      }
    }
    function warmFrom(ev) {
      var card = ev.target && ev.target.closest ? ev.target.closest('.v2b-card') : null;
      if (card) warm(card);
    }
    rail.addEventListener('pointerover', warmFrom);
    rail.addEventListener('pointerdown', warmFrom, true);
    rail.addEventListener('focusin', warmFrom);

    function write(cap, want) {
      if (!want) return;
      if ((cap.textContent || '').trim() === want) return;
      cap.textContent = want;
    }

    function capOf(card) {
      return card.querySelector('[data-bundle-item-vendor-el]') || card.querySelector('.caption');
    }

    function activeVariantId(card) {
      var sw = card.querySelector('.bundle-card__swatch.active-swatch[data-bundle-item-id]');
      return sw ? sw.getAttribute('data-bundle-item-id') : null;
    }

    function paint() {
      Array.prototype.forEach.call(rail.querySelectorAll('.v2b-card'), paintCard);
    }

    function priceOf(card) {
      var vid = activeVariantId(card);
      var h = handleOf(card);
      if (vid && Object.prototype.hasOwnProperty.call(priceMap, 'v:' + vid)) return priceMap['v:' + vid];
      if (h && Object.prototype.hasOwnProperty.call(priceMap, h)) return priceMap[h];
      return null;
    }

    function paintPrice(card) {
      var raw = card.querySelector('[data-bundle-discount-price-raw]');
      if (raw && String(raw.getAttribute('data-bundle-discount-price-raw') || '').trim()) return;

      var el = card.querySelector('.price');
      if (!el) return;
      var pair = priceOf(card);
      if (!pair || pair.indexOf('|') === -1) return;
      var parts = pair.split('|');
      if (!parts[0] || !parts[1]) return;
      var next = '<s class="v2b-was">' + parts[0] + '</s> '
               + '<span class="v2b-now">' + parts[1] + '</span>';
      if (el.innerHTML !== next) el.innerHTML = next;
    }

    function paintCard(card) {
      paintPrice(card);
      (function () {
        var cap = capOf(card);
        if (!cap) return;
        var vid = activeVariantId(card);
        var h = handleOf(card);
        var hasV = vid && Object.prototype.hasOwnProperty.call(map, 'v:' + vid);
        var hasH = h && Object.prototype.hasOwnProperty.call(map, h);
        var want = hasV ? map['v:' + vid] : (hasH ? map[h] : null);
        if (want) { write(cap, want); return; }

        if (!hasV && !hasH && h) lookUp(h, function (found) { write(cap, found); });
        var txt = cap.textContent || '';
        if (txt.indexOf('[') === -1) return;
        write(cap, txt.replace(/\[[^\]]*\]/g, '').replace(/\s*,\s*,\s*/g, ', ')
                      .replace(/^[\s,]+|[\s,]+$/g, ''));
      }());
    }

    function diagnose() {
      var d = {};
      var el = root.querySelector('[data-v2-charm-diag]');
      if (el) { try { d = JSON.parse(el.textContent); } catch (e) {} }
      var keys = Object.keys(map);
      var withValue = keys.filter(function (k) { return map[k]; }).length;
      var lines = [];
      lines.push('v2-below build ' + (d.build || 'UNKNOWN - an older file is installed'));
      lines.push('charms on this product: ' + d.charms +
                 '   their swatch siblings: ' + d.sibs +
                 '   of those, siblings whose material Shopify returned: ' + d.sibsWithMaterial);
      lines.push('collections read: ' + (d.collections || '(none listed)') +
                 '   products gathered in total: ' + d.total);
      lines.push('map printed into the page: ' + keys.length + ' entries, ' +
                 withValue + ' with a value, ' + (keys.length - withValue) + ' blank');
      lines.push('looked up in the browser so far: ' + warmed);
      var cards = rail.querySelectorAll('.v2b-card');
      lines.push('cards on the rail: ' + cards.length);
      Array.prototype.slice.call(cards, 0, 2).forEach(function (card, ci) {
        lines.push('  card ' + (ci + 1) + ':');
        Array.prototype.forEach.call(card.querySelectorAll('.bundle-card__swatch'), function (sw) {
          var id = sw.getAttribute('data-bundle-item-id');
          var url = sw.getAttribute('data-bundle-item-url') || '(no url attribute)';
          var known = Object.prototype.hasOwnProperty.call(map, 'v:' + id);
          var val = known ? (map['v:' + id] || '(blank)') : '';
          lines.push('    v:' + id + (sw.classList.contains('active-swatch') ? ' [active]' : '        ') +
                     '  ' + (known ? 'KNOWN  ' + val : 'NOT IN MAP  ' + url));
        });
      });
      var box = document.createElement('pre');
      box.setAttribute('data-v2-diagbox', '');
      box.style.cssText = 'background:#1a1a1a;color:#e7e2e9;padding:14px 16px;margin:0 0 14px;' +
        'font:12px ui-monospace,Menlo,Consolas,monospace;line-height:1.55;white-space:pre-wrap;' +
        'border-radius:0;overflow-x:auto';
      box.textContent = lines.join('\n');
      var host = rail.parentNode;
      var old = host.querySelector('[data-v2-diagbox]');
      if (old) old.parentNode.removeChild(old);
      host.insertBefore(box, rail);
    }
    var wantDiag = (window.location.search || '').indexOf('v2debug') > -1;
    if (wantDiag) {
      setTimeout(diagnose, 900);
      rail.addEventListener('click', function () { setTimeout(diagnose, 500); });
    }

    paint();
    (window.requestIdleCallback || function (f) { return setTimeout(f, 1200); })(function () {
      if (root.hasAttribute('data-debug') && window.console) {
        console.log('[v2-below] charm materials: ' + Object.keys(map).length +
          ' printed into the page, ' + warmed + ' looked up. ' +
          (warmed ? 'Add the collections holding those products to ' +
                    'v2_05_mat_collections and they become instant.' : 'Nothing needed looking up.'));
      }
    });
    var painting = false, painted = 0, PAINT_MAX = 400, railMo = null;
    try {
      railMo = new MutationObserver(function (records) {
        if (painting) return;
        if (painted > PAINT_MAX) return;
        painting = true;
        try {
          var cards = [];
          for (var i = 0; i < records.length; i++) {
            var t = records[i].target;
            var el = t && t.nodeType === 1 ? t : (t ? t.parentNode : null);
            var card = el && el.closest ? el.closest('.v2b-card') : null;
            if (card && cards.indexOf(card) === -1) cards.push(card);
          }
          if (cards.length) { painted += cards.length; cards.forEach(paintCard); }
          else { painted += 1; paint(); }
          if (painted > PAINT_MAX) {
            try { railMo.disconnect(); } catch (e) {}
            if (window.console && console.warn) {
              console.warn('[v2-below] stopped repainting the rail after '
                + PAINT_MAX + ' passes. Something else on the page is writing '
                + 'to these cards and we were taking turns with it forever. '
                + 'The cards keep their last state; the page stays responsive.');
            }
          }
        } finally { painting = false; }
      });
      railMo.observe(rail, { childList: true, subtree: true, characterData: true,
                             attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }());

  var thread = root.querySelector('[data-v2-thread]');
  var src = root.querySelector('.v2b-src');

  var chips = root.querySelectorAll('[data-v2-chip]');

  function clearThread() {
    if (!thread) return;
    while (thread.firstChild) thread.removeChild(thread.firstChild);
    Array.prototype.forEach.call(chips, function (c) { c.setAttribute('aria-pressed', 'false'); });
  }

  Array.prototype.forEach.call(chips, function (chip) {
    chip.addEventListener('click', function () {
      var i = chip.getAttribute('data-v2-chip');
      var wasOpen = !!thread.querySelector('[data-for="' + i + '"]');
      clearThread();
      if (wasOpen) return;

      var ans = src && src.querySelector('[data-v2-ans="' + i + '"]');
      if (!ans) return;
      var bub = document.createElement('div');
      bub.className = 'v2b-bub';
      bub.setAttribute('data-for', i);
      var q = document.createElement('span');
      q.className = 'q';
      q.textContent = chip.getAttribute('data-q') || chip.textContent;
      bub.appendChild(q);
      var body = document.createElement('div');
      body.className = 'a';
      body.innerHTML = ans.innerHTML;
      bub.appendChild(body);
      thread.appendChild(bub);
      chip.setAttribute('aria-pressed', 'true');
    });
  });

  var more = root.querySelector('[data-v2-more]');
  if (more) {
    var chipRow = root.querySelector('.v2b-chips');
    more.addEventListener('click', function () {
      var opening = more.getAttribute('data-open') !== '1';
      Array.prototype.forEach.call(root.querySelectorAll('.v2b-chip.extra'), function (c) {
        if (opening) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
      });
      if (chipRow) {
        if (opening) chipRow.classList.add('open');
        else { chipRow.classList.remove('open'); chipRow.scrollLeft = 0; }
      }
      if (!opening) clearThread();
      more.setAttribute('data-open', opening ? '1' : '0');
      more.textContent = opening ? more.getAttribute('data-less') : more.getAttribute('data-more');
    });
  }

  if (document.querySelector('[data-v2-groups][data-debug]') && window.console) {
    setTimeout(function () {
      var sw = root.querySelector('.v2b-card .bundle-card__swatch');
      if (!sw) { console.info('[v2-below] no swatch found - the class name is wrong'); return; }
      var out = [{ what: 'the swatch itself', tag: sw.tagName, cls: sw.className,
                   radius: getComputedStyle(sw).borderRadius,
                   size: getComputedStyle(sw).width + ' x ' + getComputedStyle(sw).height,
                   padding: getComputedStyle(sw).padding,
                   background: getComputedStyle(sw).backgroundColor }];
      ['::before', '::after'].forEach(function (pe) {
        var c = getComputedStyle(sw, pe);
        if (c.content && c.content !== 'none') {
          out.push({ what: pe, radius: c.borderRadius, size: c.width + ' x ' + c.height,
                     background: c.backgroundColor, position: c.position });
        }
      });
      Array.prototype.forEach.call(sw.querySelectorAll('*'), function (el) {
        var c = getComputedStyle(el);
        out.push({ what: 'inside', tag: el.tagName, cls: el.className,
                   radius: c.borderRadius, size: c.width + ' x ' + c.height,
                   padding: c.padding, margin: c.margin, background: c.backgroundColor });
      });
      console.info('[v2-below] swatch markup:', sw.outerHTML);
      console.table(out);
    }, 1200);
  }

  var rail = root.querySelector('[data-v2-charm-rail]');
  if (rail) {
    var prev = root.querySelector('[data-v2-charm-prev]');
    var next = root.querySelector('[data-v2-charm-next]');
    var step = function () {
      var first = rail.firstElementChild;
      return first ? first.getBoundingClientRect().width + 10 : rail.clientWidth * 0.5;
    };
    var ends = function () {
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    };
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', function () {
      clearTimeout(window.__v2railT);
      window.__v2railT = setTimeout(ends, 60);
    });
    window.addEventListener('resize', ends);
    ends();
    setTimeout(ends, 600);
  }
}());
}
v2run();
if (window.Shopify && window.Shopify.designMode) {
document.addEventListener('shopify:section:load', function () { try { v2run(); } catch (e) {} });
}
})();
